import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { FaCoins } from "react-icons/fa";
import "../../../assets/css/Customer/CustomerSettings/CustomerCoinWallet.css";
import CustomerSettingsMasterLayout from "../../../layouts/Customer/CustomerSettingsMasterLayout";
import axios from "axios";
import AppContext from "../../../context/AppContext";


const InitialsAvatar = ({ name }) => {
  const initials = name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
  return <div className="CustomerCoinWallet-avatar-initials">{initials}</div>;
};

const CustomerCoinWallet = () => {
  const navigate = useNavigate();
  const { baseUrl, authToken } = useContext(AppContext);

  const [totalbalance, setTotalBalance] = useState(0);
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  const transactions = [
    {
      id: 1,
      name: "Ahmed Raza",
      userId: "#TRD-1012",
      amount: 450,
      date: "2 Jan, 2025",
    },
    {
      id: 2,
      name: "Sara Malik",
      userId: "#TRD-1089",
      amount: 320,
      date: "14 Jan, 2025",
    },
    {
      id: 3,
      name: "Usman Tariq",
      userId: "#TRD-1134",
      amount: 780,
      date: "28 Jan, 2025",
    },
    {
      id: 4,
      name: "Fatima Noor",
      userId: "#TRD-1198",
      amount: 210,
      date: "5 Feb, 2025",
    },
    {
      id: 5,
      name: "Bilal Hussain",
      userId: "#TRD-1245",
      amount: 560,
      date: "19 Feb, 2025",
    },
    {
      id: 6,
      name: "Zainab Sheikh",
      userId: "#TRD-1301",
      amount: 1200,
      date: "3 Mar, 2025",
    },
  ];

  const handleCardClick = (id) => {
    setSelectedTransaction(id);
    navigate("/customer-ride-details");
  };

  const handleExchangeCoin = () => {
    navigate("/customer-scanner", {
      state: { totalCoins: totalbalance },
    });
  };
  useEffect(() => {
    axios
      .post(
        `${baseUrl}/customer/customerwallet/getCoinWallet`,
        {},
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      )
      .then((response) => {
        if (response.data.success === true) {
        console.log("customer coins", response.data);
          setTotalBalance(response.data.balance);
        }
      })
      .catch((error) => {
        console.log(error);
        alert("Network Error! Please try again.");
      });
  }, []);

  return (
    <CustomerSettingsMasterLayout
      screenName={"CustomerCoinWallet"}
      centered={true}
    >
      <div className="CustomerCoinWallet-wrapper">
        <Container className="CustomerCoinWallet-container mt-2">
          {/* Balance Card */}
          <div className="CustomerCoinWallet-balance-card">
            <div className="CustomerCoinWallet-balance-text">Total Coins</div>
            <div className="CustomerCoinWallet-balance-amount">
              <FaCoins size={20} className="me-2 coin-icon" />
              {Number(totalbalance || 0).toLocaleString()}
            </div>
          </div>

          {/* Tab Button */}
          <Row className="CustomerCoinWallet-single-tab">
            <Col xs={12}>
              <Button className="CustomerCoinWallet-tab-btn-active w-100">
                Trip History
              </Button>
            </Col>
          </Row>

          {/* Transaction List */}
          <div className="CustomerCoinWallet-transaction-list">
            {transactions.map((transaction) => (
              <Card
                key={transaction.id}
                className={`CustomerCoinWallet-transaction-card ${selectedTransaction === transaction.id ? "selected" : ""}`}
                onClick={() => handleCardClick(transaction.id)}
              >
                <Card.Body className="CustomerCoinWallet-card-body">
                  <Row className="align-items-center g-0 flex-nowrap">
                    <Col
                      xs="auto"
                      className="CustomerCoinWallet-avatar-col me-2"
                    >
                      <InitialsAvatar name={transaction.name} />
                    </Col>

                    <Col className="CustomerCoinWallet-user-info">
                      <div className="CustomerCoinWallet-user-name">
                        {transaction.name}
                      </div>
                      <div className="CustomerCoinWallet-user-id">
                        {transaction.userId}
                      </div>
                    </Col>

                    <Col
                      xs="auto"
                      className="CustomerCoinWallet-transaction-info ms-2"
                    >
                      <div className="CustomerCoinWallet-amount">
                        <FaCoins size={11} className="coin-icon me-1" />
                        {transaction.amount.toLocaleString()}
                      </div>
                      <div className="CustomerCoinWallet-date">
                        {transaction.date}
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            ))}
          </div>

          {/* Exchange Coin Button */}
          <div className="CustomerCoinWallet-bottom-section">
            <Button
              className="CustomerCoinWallet-exchange-btn w-100"
              onClick={handleExchangeCoin}
            >
              Exchange Coin
            </Button>
          </div>
        </Container>
      </div>
    </CustomerSettingsMasterLayout>
  );
};

export default CustomerCoinWallet;
